// extracted by mini-css-extract-plugin
export var inlineLink = "_4a-0";
export var inlineLinkButton = "_4a-1";